export default __webpack_public_path__ + "static/media/persistent_disk.df56e76f.svg";